var React = require('react');
var Link = require('react-router').Link;

var AuthenticationActions = require('../../actions/AuthenticationActions');
var Config = require('../../config/Config');
var Image = require('../Image');

var logoHiRes = require('../../images/infinite-logo-web-hi-res.png');

var Logout = React.createClass({
    statics: {
        willTransitionTo: function () {
            AuthenticationActions.logout();

            setTimeout(function () {
                window.location.href = Config.ssoLogoutUrl;
            }, 200);
        }
    },
    render: function () {
        return <div className="colorful-page-wrapper">
          <div className="center-block">
            <div className="login-block">
                <header>
                  <div className="image-block"><Image desktopSrc={logoHiRes} mobileSrc={logoHiRes} alt="User" /></div>
                  Logged Out
                </header>
                <fieldset><p>You have been successfully logged out.</p></fieldset>
                <fieldset><p><Link to="login">Login again</Link></p></fieldset>
                <footer></footer>
            </div>
          </div>
        </div>;
    }
})
module.exports = Logout;



// WEBPACK FOOTER //
// ./app/components/Authentication/Logout.js